import React from 'react'
import {trackClick} from '../../services/coreAnalytics'
import {getUser, getUserToken} from '../../services/token'

interface ContactInfoFooterProps {
  propertyTitle: string
  propertyPhone: string
  analyticsContext: string // e.g., 'manage-reservation', 'update-payment'
  linkClassName?: string // Optional custom classes for links
  containerClassName?: string // Optional custom classes for container
}

const ContactInfoFooter: React.FC<ContactInfoFooterProps> = ({
  propertyTitle,
  propertyPhone,
  analyticsContext,
  linkClassName = 'text-cabana underline hover:opacity-80',
  containerClassName = 'pt-6 text-center italic'
}) => {
  const handleEmailClick = (e: React.MouseEvent) => {
    e.preventDefault()
    const token = getUserToken()
    const user = token ? getUser(token) : null
    const emailUrl = 'mailto:hello@placemakr.com'
    trackClick(`${analyticsContext}-contact-email`, emailUrl, user?.email)
    window.location.href = emailUrl
  }

  const handlePhoneClick = (e: React.MouseEvent) => {
    e.preventDefault()
    const token = getUserToken()
    const user = token ? getUser(token) : null
    const phoneUrl = `tel:${propertyPhone}`
    trackClick(`${analyticsContext}-contact-phone`, phoneUrl, user?.email)
    window.location.href = phoneUrl
  }

  return (
    <div className={containerClassName} aria-label="Contact Information">
      Need to do something else? You can email us at{' '}
      <a
        href="mailto:hello@placemakr.com"
        target="_blank"
        className={linkClassName}
        aria-label="Email Placemaker"
        onClick={handleEmailClick}
      >
        hello@placemakr.com
      </a>{' '}
      or call {propertyTitle} at{' '}
      <a
        href={`tel:${propertyPhone}`}
        target="_blank"
        className={linkClassName}
        aria-label={`Call ${propertyTitle}`}
        onClick={handlePhoneClick}
      >
        {propertyPhone}
      </a>
      .
    </div>
  )
}

export default ContactInfoFooter
